import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppCtxComponent } from 'js/reactAppCtx';
import SearchBoxViewModel from 'viewmodel/SearchBoxViewModel';
import { registerDynImportEntry } from 'js/moduleLoader';
import 'viewmodel/AccSearchBoxViewModel';

registerDynImportEntry('image/cmdSearch16.svg', () => import('image/cmdSearch16.svg'));
registerDynImportEntry('image/cmdClearText24.svg', () => import('image/cmdClearText24.svg'));
registerDynImportEntry('image/miscSortedDescending10.svg', () => import('image/miscSortedDescending10.svg'));

export default class DesSearchBox extends HTMLElement {

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['accsessionid', 'acc-session-id', 'locale', 'collaborationspaceid', 'collaborationspace-id', 'project-id', 'hide-category', 'remove-category', 'search-input', 'show-ownership-filter', 'extensions-src', 'ix-enabled', 'ixenabled'];
    }

    get accsessionid() {
        return this.getAttribute('acc-session-id') || this.getAttribute('accsessionid');
    }

    get extensionssrc() {
        return this.getAttribute('extensions-src') || this.getAttribute('extensionssrc');
    }

    get ixenabled() {
        window.ixEnabled = this.getAttribute('ix-enabled') || this.getAttribute('ixenabled');
        return this.getAttribute('ix-enabled') || this.getAttribute('ixenabled');
    }

    connectedCallback() {
        this.classList.add('afx-content-background');
        this.createReactElement();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        ReactDOM.unmountComponentAtNode(this);
        this.createReactElement();
    }

    createReactElement() {
        ReactDOM.render(
            <AppCtxComponent>
                {React.createElement(
                    SearchBoxViewModel,
                    {
                        accsessionid: this.accsessionid,
                        locale: this.locale,
                        ...this.getProps()
                    },
                    React.createElement('slot')
                )}
            </AppCtxComponent>,
            this);
    }

    getProps() {
        return {
            viewId: 'searchBoxView',
            viewPath: 'viewPath',
            extensionSrc: this.extensionssrc,
            hideCategory: this.getAttribute('hide-category'),
            showOwnershipFilter: this.getAttribute('show-ownership-filter'),
            removecategory: this.getAttribute('remove-category'),
            searchInput: this.getAttribute('search-input'),
            ixEnabled: this.ixenabled

        };
    }


    disconnectedCallback() {
        ReactDOM.unmountComponentAtNode(this);
    }
}

if (!window.customElements.get('des-search-box')) {
    window.customElements.define(
        'des-search-box',
        DesSearchBox
    );
}
